<novo-loading *ngIf="loading"></novo-loading>

<div *ngIf="!loading">
  <header>
    <novo-header title="MSP Companies">
      Companies
    </novo-header>
  </header>

  <div class="content">
    <novo-list>
      <novo-list-item *ngFor="let company of companies">
        <item-header>
          <item-title>{{company.name}}</item-title>
        </item-header>
        <item-content>
          <p *ngIf="company.address">
            {{company.address.address1}}<br>
            {{company.address.city}}, {{company.address.state}} {{company.address.zip}}
          </p>
        </item-content>
      </novo-list-item>
    </novo-list>
  </div>
</div> 